import type uk from "./uk";

/** Каталог RU — повинен повторювати форму `uk` (типобезпека парності ключів). */
const ru: typeof uk = {
  app: {
    title: "Salonos",
  },
  layout: {
    aria: {
      sidebar: "Боковая навигация",
      sections: "Разделы",
      moreSections: "Разделы настроек",
      topbar: "Верхняя панель",
      bottomnav: "Нижняя навигация",
    },
    account: {
      menuLabel: "Меню аккаунта",
      logout: "Выйти",
    },
    more: {
      title: "Ещё",
      description: "Разделы настроек салона",
      close: "Закрыть",
    },
  },
  nav: {
    zones: {
      daily: "Ежедневная работа",
      settings: "Настройки салона",
    },
    journal: "Записи",
    schedule: "График",
    more: "Ещё",
    clients: "Клиенты",
    summary: "Итоги",
    masters: "Мастера",
    services: "Услуги",
    salonProfile: "Профиль салона",
  },
  sections: {
    inDevelopment: "Раздел в разработке",
    inDevelopmentHint: "Этот раздел скоро появится.",
  },
  services: {
    title: "Услуги",
    subtitle: "Управляйте каталогом услуг салона",
    loading: "Загрузка…",
    listError: "Не удалось загрузить услуги",
    retry: "Попробовать снова",
    saving: "сохранение…",
    assignedCount: "{count} мастер | {count} мастера | {count} мастеров",
    row: {
      addMaster: "Мастер",
    },
    draft: {
      placeholder: "Добавить услугу",
      placeholderNext: "Следующая услуга…",
      addToCategory: "Добавить услугу в {name}",
    },
    actions: {
      rename: "Переименовать",
      delete: "Удалить",
      save: "Сохранить",
      cancel: "Отменить",
      retry: "Повторить",
      dismiss: "Убрать",
      confirm: "Подтвердить",
      addService: "Добавить услугу",
      move: "Переместить в категорию",
      moveToCategory: "Переместить в категорию",
      moveHere: "Переместить сюда",
    },
    detail: {
      sheetTitle: "Мастера услуги",
      ctxLabel: "Услуга",
      mastersSection: "Мастера",
      masterCount: "{count} мастер | {count} мастера | {count} мастеров",
      addMaster: "Добавить мастера",
      manageMenuLabel: "Управление услугой",
      renameConfirm: "Подтвердить",
      renameCancel: "Отменить",
      currentCategoryHint: "сейчас здесь",
      empty: {
        title: "К этой услуге ещё не привязаны мастера",
        body: "Добавьте мастера и задайте, сколько стоит и длится услуга у него. Без мастера услуга не появится в записи.",
      },
      master: {
        meta: "{duration} мин · {price} · буфер {buffer} мин",
        bufferMeta: "буфер {buffer} мин",
        edit: "Изменить",
      },
      assignedError: "Не удалось загрузить мастеров",
      retry: "Повторить",
      addMoreMaster: "+ Добавить ещё мастера",
      done: "Готово",
      bannerAdded: "{name} добавлен в «{service}»",
      closeLabel: "Закрыть",
    },
    categories: {
      title: "Без категории",
      add: "Новая категория",
      saved: "Категория сохранена",
      deleted: "Категория удалена",
      addPlaceholder: "Название категории",
      uncategorized: "Без категории",
      assignHint: "Чтобы назначить категорию, откройте услугу → ⋯ → «Переместить в категорию».",
      renameCategory: "Переименовать категорию",
      deleteCategory: "Удалить категорию",
      deleteKeepsServices: "Услуги перемещаются в «Без категории», а не удаляются.",
      count: "{count} услуга | {count} услуги | {count} услуг",
    },
    delete: {
      confirm: "Удалить «{name}»?",
      base: "Услуга будет удалена из каталога. Это действие нельзя отменить.",
      assignedWarning: "К услуге прикреплён {count} мастер. Он открепится вместе с ней. | К услуге прикреплено {count} мастера. Они открепятся вместе с ней. | К услуге прикреплено {count} мастеров. Они открепятся вместе с ней.",
      blocked: "Услуга назначена мастерам. Сначала снимите её в карточках мастеров.",
    },
    errors: {
      invalidName: "Укажите корректное название (до 200 символов).",
      notFound: "Услуга уже удалена.",
      inUse: "Услуга назначена мастерам. Сначала снимите её в карточках мастеров.",
      serviceInUse: "У мастера есть запланированные записи на эту услугу. Отмените или перенесите их.",
    },
    empty: {
      category: "В этой категории пока нет услуг.",
      firstRun: {
        title: "Каталог услуг пуст",
        body: "Сгруппируйте услуги по категориям — клиентам будет легче ориентироваться.",
        cta: "Новая категория",
      },
    },
    a11y: {
      editLabel: "Название услуги",
      savedAnnounce: "{name} сохранено",
      deletedAnnounce: "{name} удалено",
      serviceActions: "Действия услуги «{name}»",
      categoryActions: "Действия категории «{name}»",
      moveLabel: "Категория для «{name}»",
      collapseCategory: "Свернуть категорию «{name}»",
      expandCategory: "Развернуть категорию «{name}»",
    },
    assign: {
      picker: {
        title: "Выберите мастера",
        search: "Поиск мастера…",
        next: "Далее — настроить",
        createNew: "Создать нового мастера",
      },
      config: {
        save: "Сохранить",
        cancel: "Отменить",
        detach: "Открепить",
      },
      create: {
        nameLabel: "Имя",
        phoneLabel: "Телефон",
        hint: "Мастер привязан к услуге — изменить можно на странице мастеров",
        mastersLink: "Страница мастеров",
      },
    },
    detach: {
      trigger: "Открепить мастера",
      dangerLabel: "Опасная зона",
      hint: "Мастер больше не будет оказывать эту услугу. Цена и продолжительность этой связи будут утеряны.",
      confirmTitle: "Открепить мастера от услуги?",
      confirmBody: "{master} больше не будет оказывать услугу «{service}». Введённые цена и продолжительность будут удалены — при повторном назначении их нужно будет указать заново.",
      confirm: "Открепить",
      close: "Закрыть",
    },
  },
  masters: {
    title: "Мастера",
    subtitle: "Добавляйте мастеров салона, редактируйте и удаляйте их профили.",
    add: "Добавить мастера",
    backToList: "К списку",
    setupHint: {
      services: "Выберите мастера, чтобы добавить цены и время услуг",
      schedule: "Выберите мастера, чтобы настроить расписание работы",
    },
    tabs: {
      profile: "Профиль",
      photo: "Фото",
      schedule: "Расписание",
      services: "Услуги",
    },
    photo: {
      empty: "Фото пока нет",
      hint: "JPEG или PNG",
      actions: {
        upload: "Загрузить фото",
        replace: "Заменить фото",
        remove: "Удалить фото",
        confirm: "Загрузить",
        cancel: "Отмена",
      },
      remove: {
        title: "Удалить фото?",
        description: "Фото мастера будет удалено. Это действие можно отменить, загрузив фото снова.",
        confirm: "Удалить",
      },
      a11y: {
        preview: "Фото мастера {name}",
        uploaded: "Фото обновлено",
        removed: "Фото удалено",
        changeButton: "Изменить фото мастера",
      },
      errors: {
        unsupportedType: "Поддерживаются только JPEG и PNG",
        invalidImage: "Не удалось прочитать изображение или оно слишком большое по размерам",
        tooLarge: "Файл слишком большой",
        uploadFailed: "Не удалось загрузить фото",
        masterGone: "Мастера уже нет, обновите список",
      },
    },
    loading: "Загрузка…",
    listError: "Не удалось загрузить мастеров",
    retry: "Попробовать снова",
    empty: {
      title: "Мастеров пока нет",
      body: "Добавьте первого мастера — он появится в списке и станет доступен для записей.",
      cta: "Добавить мастера",
    },
    loadError: "Не удалось загрузить мастера",
    fields: {
      firstName: "Имя",
      lastName: "Фамилия",
      middleName: "Отчество",
      email: "Email",
      phone: "Телефон",
      hint: {
        middleName: "необязательно",
      },
    },
    actions: {
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      create: "Добавить мастера",
    },
    delete: {
      title: "Удалить мастера?",
      confirm: "Действие необратимо. Профиль мастера {name} будет удалён без возможности восстановления.",
      blocked: "У мастера есть назначенные услуги. Сначала снимите их, затем профиль можно удалить.",
    },
    notFound: {
      title: "Мастера уже нет",
      body: "Этот мастер удалён или ссылка неверна.",
      backCta: "К списку",
    },
    a11y: {
      createdAnnounce: "Мастер {name} добавлен",
      savedAnnounce: "Изменения профиля {name} сохранены",
      deletedAnnounce: "Мастер удалён",
      avatarLabel: "Аватар мастера",
    },
    sections: {
      profile: "Профиль",
      services: "Услуги",
      schedule: "Расписание",
      portfolio: "Портфолио",
      dangerZone: "Опасная зона",
    },
    dangerZone: {
      description: "Удаление мастера необратимо.",
    },
    errors: {
      firstNameRequired: "Введите имя",
      lastNameRequired: "Введите фамилию",
      nameTooLong: "Слишком длинное значение (максимум 100 символов)",
      invalidName: "Проверьте ФИО мастера",
      invalidFirstName: "Проверьте имя",
      invalidMiddleName: "Проверьте отчество",
      invalidLastName: "Проверьте фамилию",
      invalidEmail: "Неверный формат email",
      invalidPhone: "Неверный формат телефона",
      inUse: "У мастера есть назначенные услуги. Сначала снимите их.",
      notFound: "Мастера уже нет",
    },
    schedule: {
      weekdays: {
        "1": "Понедельник",
        "2": "Вторник",
        "3": "Среда",
        "4": "Четверг",
        "5": "Пятница",
        "6": "Суббота",
        "7": "Воскресенье",
      },
      dayOff: "Выходной",
      from: "Начало",
      to: "Конец",
      save: "Сохранить расписание",
      edit: "Редактировать расписание",
      loadError: "Не удалось загрузить расписание",
      empty: {
        title: "Расписание не настроено",
        description: "Без расписания мастер недоступен для онлайн-записи.",
      },
      a11y: {
        saved: "Расписание сохранено",
        dayToggle: "{day} — рабочий день",
        startLabel: "Начало — {day}",
        endLabel: "Конец — {day}",
        loading: "Загрузка расписания…",
      },
      setup: {
        cta: "Настроить расписание",
        title: "Настроить расписание",
        presets: {
          monFri: "Пн-Пт",
          monSat: "Пн-Сб",
          daily: "Ежедневно",
          clearAll: "Очистить",
        },
        apply: "Применить",
        close: "Закрыть",
      },
      errors: {
        startBeforeEnd: "Начало должно быть раньше конца",
        invalid_working_hours: "Проверьте рабочие часы (начало раньше конца, шаг 15 мин)",
        invalid_weekday: "Неверный день недели",
        duplicate_weekday: "День недели указан дважды",
        saveFailed: "Не удалось сохранить расписание",
      },
    },
    services: {
      saved: "Услуга сохранена",
      removed: "Услуга снята",
      unknownService: "[Удалено]",
      unknownMaster: "[Удалён]",
      errors: {
        serviceRequired: "Выберите услугу",
        invalidDuration: "Укажите корректную длительность (минуты, 1–480)",
        invalidPrice: "Укажите корректную цену (от 0)",
        invalidBuffer: "Укажите корректный буфер (минуты, 0–120)",
        serviceGone: "Услуга удалена из каталога. Список обновлён.",
        linkGone: "Назначение уже снято в другой сессии",
        serviceInUse: "У мастера есть запланированные записи на эту услугу. Отмените или перенесите их.",
      },
      add: "Добавить услугу",
      loading: "Загрузка…",
      listError: "Не удалось загрузить услуги",
      retry: "Попробовать снова",
      empty: {
        title: "Услуг ещё нет",
        body: "Добавьте услуги, которые предоставляет этот мастер.",
        cta: "Добавить услугу",
      },
      emptyCatalog: {
        title: "Сначала создайте услуги",
        body: "В салоне ещё нет услуг. Создайте их в разделе «Услуги».",
        cta: "К услугам",
      },
      row: {
        summary: "{duration} мин · {price} · буфер {buffer} мин",
      },
      units: {
        min: "мин",
        hour: "ч",
      },
      actions: {
        edit: "Редактировать",
        detach: "Убрать",
        save: "Сохранить",
        cancel: "Отмена",
      },
      form: {
        addTitle: "Добавить услугу",
        editTitle: "Редактировать услугу",
        service: "Услуга",
        servicePlaceholder: "Выберите услугу",
        duration: "Длительность",
        price: "Цена, €",
        buffer: "Буфер, мин",
        bufferHint: "Время после записи",
      },
      detach: {
        title: "Убрать услугу?",
        description: "Услуга будет откреплена от мастера. Атрибуты связи будут потеряны.",
        confirm: "Убрать",
      },
      a11y: {
        addedAnnounce: "{name} добавлено",
        savedAnnounce: "{name} обновлено",
        detachedAnnounce: "{name} убрано",
      },
    },
    portfolio: {
      title: "Портфолио",
      description: "Фотографии работ мастера",
      empty: "Фотографий работ ещё нет",
      loading: "Загрузка...",
      error: "Ошибка загрузки",
      retry: "Повторить",
      addPhoto: "Добавить фото",
      full: "Портфолио заполнено (максимум 20 фото)",
      cover: "Обложка",
      upload: {
        title: "Добавить фото",
        fileLabel: "Фото работы",
        serviceLabel: "Услуга (необязательно)",
        noTag: "Без тега (общая работа)",
        submit: "Загрузить",
        cancel: "Отмена",
        preview: "Предпросмотр",
      },
      remove: {
        title: "Удалить фото",
        description: "Это фото будет удалено из портфолио. Восстановить невозможно.",
        confirm: "Удалить",
        cancel: "Отмена",
      },
      errors: {
        full: "Портфолио уже содержит 20 фото",
        serviceNotOffered: "Мастер не предоставляет эту услугу",
        unsupportedType: "Неподдерживаемый тип изображения (только JPEG, PNG)",
        invalidImage: "Изображение повреждено или невалидно",
        tooLarge: "Файл слишком большой",
        reorderFailed: "Не удалось изменить порядок — попробуйте ещё раз",
        uploadFailed: "Ошибка загрузки",
        masterGone: "Мастер не найден",
      },
      a11y: {
        photoAlt: "Фото работы",
        taggedPhotoAlt: "Фото работы — {service}",
        photoAdded: "Фото добавлено в портфолио",
        photoDeleted: "Фото удалено из портфолио",
        photoMoved: "Фото перемещено на позицию {position} из {total}",
        addPhoto: "Добавить фото",
        moveBack: "Переместить назад",
        moveForward: "Переместить вперёд",
        deletePhoto: "Удалить фото",
      },
    },
  },
  journal: {
    loadError: "Не удалось загрузить расписание",
    retry: "Попробовать снова",
    toolbar: {
      today: "Сегодня",
      prevDay: "Предыдущий день",
      nextDay: "Следующий день",
      dateLabel: "Навигация по датам",
      viewSwitcher: "Переключить вид",
      viewGrid: "Сетка",
      viewList: "Список",
    },
    masterTabs: {
      all: "Все",
      dayOff: "вых.",
      dayOffAria: "выходной",
    },
    workingCount: "{n} из {m} мастеров",
    summary: {
      completed: "выполнено {count}",
      revenue: "выручка {amount}",
    },
    empty: {
      noMasters: "Сегодня никто не работает",
      noBookings: "Записей нет",
      selectMaster: "Выберите мастера во вкладках",
    },
    actions: {
      addBooking: "Новая запись",
      reschedule: "Перенести",
      cancel: "Отменить",
    },
    create: {
      title: "Новая запись",
      close: "Закрыть",
      master: "Мастер",
      selectMaster: "Выберите мастера",
      service: "Услуга",
      selectService: "Выберите услугу",
      clientName: "Имя клиента",
      clientPhone: "Телефон",
      time: "Время",
      submit: "Добавить запись",
      servicesLoadError: "Не удалось загрузить услуги. Попробуйте выбрать мастера снова.",
      noServicesForMaster: "Для этого мастера услуги не настроены",
    },
    reschedule: {
      title: "Перенести запись",
      close: "Закрыть",
      master: "Мастер (изменить)",
      selectMaster: "Выберите мастера",
      date: "Дата",
      dateGroupLabel: "Дата переноса",
      currentDay: "текущая",
      todayDay: "сегодня",
      time: "Новое время",
      submit: "Сохранить изменения",
    },
    cancel: {
      title: "Отменить запись",
      description: "Запись будет отменена. Это действие нельзя отменить.",
      reason: "Причина (необязательно)",
      confirm: "Отменить запись",
      close: "Назад",
    },
    dateTimePicker: {
      idleHint: "Выберите мастера и услугу для просмотра доступного времени",
      timeLabel: "Выберите время",
      hoursLabel: "Часы",
      minutesLabel: "Минуты",
    },
    slotPicker: {
      empty: "Нет свободных слотов",
      loading: "Загрузка слотов…",
      error: "Не удалось загрузить слоты",
      emptyForDate: "На выбранную дату свободных слотов нет",
      emptyToday: "На сегодня свободного времени не осталось",
    },
    errors: {
      slotTaken: "Слот только что заняли. Выберите другое время.",
      concurrentModification: "Запись изменилась. Обновите и повторите.",
      outsideWorkingHours: "Время вне рабочих часов мастера.",
      notEditable: "Эту запись больше нельзя редактировать.",
      serviceNotConfigured: "Мастер больше не предоставляет эту услугу.",
      invalidPhone: "Неверный формат телефона.",
      invalidClientName: "Укажите корректное имя клиента.",
      notFound: "Запись больше не существует.",
      reloadAction: "Обновить",
    },
    a11y: {
      blockLabel: "{service}, {client}, {start}–{end}, {master}, {status}",
      createdAnnounce: "Запись создана",
      rescheduledAnnounce: "Запись перенесена",
      cancelledAnnounce: "Запись отменена",
      bookingActions: "Действия с записью",
      bookFreeSlot: "Записать на {time}",
    },
    status: {
      scheduled: "Запланировано",
      completed: "Выполнено",
      cancelled: "Отменено",
    },
    agenda: {
      dayOff: {
        title: "Выходной",
        subtitle: "{name} сегодня не работает. Записи недоступны.",
      },
      empty: {
        title: "Записей на этот день нет",
        workingHours: "{name} работает {start}–{end}",
      },
      duration: {
        hm: "{h} ч {m} мин",
        h: "{h} ч",
        m: "{m} мин",
      },
      freeSlot: {
        start: "Смена начинается в {time} · {duration}",
        end: "Смена завершена · свободно {duration}",
        midLabel: "Свободно",
        book: "Записать",
      },
    },
    timeBlock: {
      busy: "Занято",
      createTitle: "Заблокировать время",
      deleteTitle: "Удалить блок",
      deleteDescription: "Этот временной блок будет удалён для мастера.",
      masterLabel: "Мастер",
      selectMaster: "Выберите мастера",
      rangeLabel: "Временной диапазон",
      reasonLabel: "Причина",
      reasonPlaceholder: "Напр.: обед, перерыв",
      submit: "Заблокировать",
      close: "Закрыть",
      confirmDelete: "Удалить",
      cancelDelete: "Отмена",
      createdAnnounce: "Время заблокировано",
      errors: {
        overlapBlock: "Это время пересекается с другим блоком мастера.",
        overlapBooking: "Это время пересекается с существующей записью.",
        invalidRange: "Время окончания должно быть позже времени начала.",
        reasonTooLong: "Причина слишком длинная (макс. 200).",
        notFound: "Блок уже удалён.",
      },
    },
    rebuildPlaceholder: "Раздел в разработке",
  },
  auth: {
    login: {
      title: "Войти в кабинет",
      submit: "Войти",
      forgotPassword: "Забыли пароль?",
      noAccount: "Нет аккаунта?",
      signUp: "Зарегистрироваться",
      supportPrompt: "Возникли проблемы?",
      supportLink: "Напишите в поддержку",
    },
    brand: {
      title: "Управляйте компанией в одном месте",
      subtitle: "Записи, мастера и аналитика — в единой панели.",
      props: [
        "Онлайн-запись 24/7",
        "Журнал и напоминания клиентам",
        "Аналитика и итоги дня",
      ],
    },
    fields: {
      email: "Email",
      emailPlaceholder: "you{'@'}example.com",
      password: "Пароль",
      passwordPlaceholder: "Ваш пароль",
      remember: "Запомнить меня",
    },
    errors: {
      invalidCredentials: "Неверный email или пароль",
      validation: {
        emailRequired: "Введите email",
        emailInvalid: "Неверный формат email",
        passwordRequired: "Введите пароль",
      },
    },
  },
  onboarding: {
    title: 'Настроим салон',
    subtitle: 'Выполните шаги, чтобы открыть салон для клиентов',
    progress: '{n} из {total}',
    steps: {
      services: {
        label: 'Услуги',
        desc: 'Добавьте перечень услуг, которые предоставляет ваш салон',
      },
      masters: {
        label: 'Мастера',
        desc: 'Добавьте мастеров, которые работают в вашем салоне',
      },
      pricing: {
        label: 'Цены и время услуг',
        desc: 'Установите продолжительность и стоимость каждой услуги',
        lockHint: 'Сначала добавьте услуги и мастеров',
      },
      schedule: {
        label: 'Расписание работы мастеров',
        desc: 'Укажите часы работы каждого мастера',
        lockHint: 'Сначала добавьте мастера',
      },
      profile: {
        label: 'Профиль салона',
        desc: 'Заполните информацию о салоне для сайта',
        tag: 'для сайта',
      },
    },
    cta: {
      start: 'Начать',
      open: 'Открыть',
      showHint: 'Показать подсказку',
    },
    fullSetup: {
      title: 'Полная настройка завершена',
      description: 'Салон настроен и виден клиентам',
    },
    stateError: 'Не удалось проверить состояние, попробуйте обновить',
    retry: 'Обновить',
  },
  errors: {
    validation: "Проверьте введённые данные",
    sessionExpired: "Сессия завершена. Войдите снова",
    forbidden: "Действие отклонено. Обновите страницу и попробуйте снова",
    notFound: "Не найдено",
    conflict: "Действие невозможно выполнить: ресурс используется",
    rateLimited: "Слишком много попыток. Попробуйте позже",
    server: "Что-то пошло не так. Попробуйте позже",
    network: "Сервер временно недоступен. Попробуйте ещё раз",
    unknown: "Произошла ошибка. Попробуйте позже",
    boot: {
      title: "Не удалось загрузить кабинет",
      description: "Проверьте соединение и попробуйте снова",
      retry: "Попробовать снова",
      loading: "Загрузка кабинета…",
    },
  },
  publicPages: {
    signup: {
      title: "Регистрация",
      subtitle: "Самостоятельная регистрация скоро появится. Напишите нам — и мы создадим ваш кабинет.",
      backToLogin: "Вернуться ко входу",
    },
    forgotPassword: {
      title: "Восстановление пароля",
      subtitle: "Сброс пароля скоро появится. Напишите в поддержку — мы поможем войти.",
      backToLogin: "Вернуться ко входу",
    },
  },
  clients: {
    title: "Клиенты",
    subtitle: "Карточки клиентов салона: добавляйте, находите, редактируйте и удаляйте.",
    add: "Добавить клиента",
    backToList: "К списку",
    loading: "Загрузка…",
    listError: "Не удалось загрузить клиентов",
    loadError: "Не удалось загрузить клиента",
    retry: "Попробовать снова",
    search: {
      label: "Найти клиента",
      placeholder: "Имя или телефон",
      clear: "Очистить поиск",
      searching: "Поиск…",
      minLengthHint: "Введите не менее 2 символов для поиска.",
      error: "Не удалось выполнить поиск",
    },
    results: {
      title: "Результаты",
      limitHint: "Показаны первые {count} совпадений. Уточните запрос, чтобы сузить.",
      empty: "Ничего не найдено",
      emptyBody: "Проверьте написание или создайте новую карточку клиента.",
      emptyCta: 'Создать „{query}”',
    },
    recent: {
      title: "Недавние",
      hint: "Недавно добавленные клиенты. Чтобы найти кого угодно в полной базе — воспользуйтесь поиском выше.",
    },
    empty: {
      title: "Клиентов ещё нет",
      body: "Добавьте первого клиента — его карточка появится в списке.",
      cta: "Добавить клиента",
    },
    fields: {
      firstName: "Имя",
      lastName: "Фамилия",
      phone: "Телефон",
      email: "Email",
      hint: { optional: "необязательно" },
    },
    create: {
      title: "Новый клиент",
      close: "Закрыть",
      submit: "Добавить клиента",
    },
    actions: {
      create: "Добавить клиента",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
    },
    delete: {
      title: "Удалить клиента?",
      confirm: "Действие необратимо. Карточка клиента {name} будет удалена без возможности восстановления.",
    },
    notFound: {
      title: "Клиента уже нет",
      body: "Этот клиент удалён или ссылка неверна.",
      backCta: "К списку",
    },
    dangerZone: {
      description: "Удаление клиента необратимо.",
    },
    a11y: {
      createdAnnounce: "Клиент {name} добавлен",
      savedAnnounce: "Изменения карточки {name} сохранены",
      deletedAnnounce: "Клиент удалён",
      searchResults: "Найдено {count}",
      avatarLabel: "Аватар клиента",
    },
    errors: {
      firstNameRequired: "Введите имя",
      phoneRequired: "Введите телефон",
      nameTooLong: "Слишком длинное значение (максимум 100 символов)",
      invalidName: "Проверьте имя и фамилию",
      invalidEmail: "Неверный формат email",
      invalidPhone: "Неверный формат телефона",
      phoneExists: "Клиент с таким номером телефона уже существует",
      notFound: "Клиента уже нет",
    },
  },
  salon: {
    title: "Профиль салона",
    loading: "Загрузка…",
    loadError: "Не удалось загрузить профиль салона",
    retry: "Попробовать снова",
    profile: {
      title: "Основная информация",
      fields: {
        name: "Название салона",
        address: "Адрес",
        phone: "Телефон",
        description: "Описание",
      },
      hint: {
        name: "обязательно",
        description: "до 1000 символов",
      },
      save: "Сохранить",
      saved: "Изменения сохранены",
      errors: {
        nameRequired: "Укажите название салона",
        nameInvalid: "Проверьте название (до 255 символов)",
        addressTooLong: "Адрес слишком длинный (до 255 символов)",
        phoneTooLong: "Телефон слишком длинный (до 32 символов)",
        descriptionTooLong: "Описание слишком длинное (до 1000 символов)",
        saveFailed: "Не удалось сохранить",
        notFound: "Профиль салона не найден",
      },
    },
    gallery: {
      title: "Фото интерьера",
      loadError: "Не удалось загрузить фото",
      empty: "Добавьте первое фото интерьера",
      addPhoto: "Добавить фото",
      uploaded: "Фото загружено",
      deleted: "Фото удалено",
      full: "Максимум 10 фото",
      errors: {
        full: "Достигнут максимум 10 фото",
        unsupportedType: "Поддерживаются только JPEG и PNG",
        invalidImage: "Не удалось прочитать изображение",
        tooLarge: "Файл слишком большой",
        uploadFailed: "Не удалось загрузить фото",
        reorderFailed: "Не удалось изменить порядок",
      },
      a11y: {
        photoAlt: "Фото интерьера {n}",
        moveLeft: "Переместить фото {n} левее",
        moveRight: "Переместить фото {n} правее",
        delete: "Удалить фото {n}",
        moved: "Фото перемещено на позицию {pos} из {total}",
        cover: "Главное фото",
      },
      deleteConfirm: {
        title: "Удалить фото?",
        description: "Фото будет удалено безвозвратно.",
        cancel: "Отмена",
        confirm: "Удалить",
      },
    },
  },
  records: {
    dayEmpty: "В этот день не работает ни один мастер",
    offWork: {
      label: "вне графика",
    },
    actions: {
      pastTooltip: "Прошедшая запись",
    },
    aria: {
      gridLabel: "Расписание",
      createCell: "Выбрать действие для ячейки",
      dateStrip: "Выбор даты",
    },
    createStub: {
      title: "Скоро",
      message: "Создание записи будет доступно в ближайшее время",
    },
    chooser: {
      title: "Выберите действие",
      createBooking: "Создать запись",
      blockTime: "Заблокировать время",
      cancel: "Отмена",
      close: "Закрыть",
    },
    createFlow: {
      sections: {
        client: "Клиент",
        service: "Услуга",
        time: "Время",
      },
      clientStep: {
        searchPlaceholder: "Имя или телефон…",
        minLengthHint: "Введите минимум 2 символа",
        searching: "Поиск…",
        limited: "Показаны первые результаты",
        emptyTitle: "Ничего не найдено",
        addNew: "Добавить нового клиента",
      },
      inlineCreate: {
        title: "Новый клиент",
        firstName: "Имя",
        phone: "Телефон",
        lastName: "Фамилия",
        optional: "(необязательно)",
        submit: "Создать и продолжить",
        back: "Назад к поиску",
        phoneExists: "Клиент с таким телефоном уже существует",
        createError: "Не удалось создать клиента",
      },
      summary: {
        change: "Изменить",
      },
      time: {
        nearestHint: "{tapped} недоступно — выбрали {chosen}",
        emptyDay: "Свободного времени на этот день нет",
      },
      noServiceGuard: "Выберите услугу для сохранения записи",
    },
  },
  schedule: {
    title: "График",
    loading: "Загрузка…",
    loadError: "Не удалось загрузить график",
    retry: "Попробовать снова",
    empty: {
      title: "График отсутствует",
      body: "Добавьте мастеров и настройте их график.",
    },
    nav: {
      today: "Сегодня",
      todayAria: "Вернуться к сегодня",
      todayAnnounce: "Возвращено к текущему месяцу",
      monthPickerAria: "Выбрать месяц",
      monthSelectedAnnounce: "Выбран {month} {year}",
    },
    cell: {
      working: "Рабочий день",
      dayOff: "вых",
      notSet: "не задано",
      aria: {
        working: "{master}, {date} — рабочее окно {start}–{end}",
        dayOff: "{master}, {date} — выходной",
        notSet: "{master}, {date} — расписание не задано",
      },
    },
    sheet: {
      title: "Действия",
      createBooking: "Создать запись",
      fieldLabel: "Рабочие часы этой даты",
      save: "Сохранить",
      invalidWindow: "Конец должен быть позже начала",
      close: "Закрыть",
    },
    a11y: {
      gridLabel: "Сетка графика",
      masterColumn: "Мастер",
      loading: "Загрузка графика…",
    },
    header: {
      setup: "Настроить",
    },
    mode: {
      banner: "Режим настройки",
      subtitle: "выберите ячейки для изменения",
      exit: "Отменить",
      enteredAnnounce: "Включён режим настройки расписания",
    },
    selection: {
      selectColumnAria: "Выделить весь столбец — {date}",
      selectRowAria: "Выделить всю строку — {master}",
      cellSelectedAria: "{master}, {date} — выбрано",
    },
    editor: {
      dayOff: "Выходной",
      start: "Начало",
      end: "Конец",
      counter: "Обновить {count} ячейку | Обновить {count} ячейки | Обновить {count} ячеек",
      apply: "Применить",
    },
    bulk: {
      confirmTitle: "Применить расписание?",
      confirmWindow: "Установить {start}–{end} для {count} ячеек.",
      confirmDayOff: "Отметить {count} ячеек как выходной.",
      confirmOverwrite: "Из них {count} уже имеют часы — они будут заменены.",
      applyingLabel: "Применение…",
      appliedToast: "Расписание обновлено",
      partialHint: "Дни без заданных часов показаны как выходной. Чтобы задать часы, отредактируйте эти дни отдельно.",
      conflictBlocked: "На некоторых датах есть записи, которые не вписываются в новое окно. Сначала разберитесь с ними в журнале.",
      masterGone: "Мастер больше не существует. Расписание обновлено.",
      invalidWindow: "Некорректное рабочее окно.",
      genericError: "Не удалось применить расписание. Попробуйте ещё раз.",
    },
    filter: {
      title: "Показать мастеров",
      subtitle: "Скрытые мастера исчезают из расписания. Записи и данные не изменятся.",
      visibleOf: "Видно {n} из {m}",
      showAll: "Показать всех",
      done: "Готово",
      triggerLabel: "Мастера",
      triggerAria: "Фильтр мастеров, скрыто {count}",
      allHiddenTitle: "Все мастера скрыты",
      allHiddenBody: "Вы скрыли всех мастеров. Верните их в расписание, чтобы увидеть график.",
    },
  },
  monthPicker: {
    title: "Выбор месяца",
    prevYear: "Предыдущий год",
    nextYear: "Следующий год",
    currentSuffix: ", текущий месяц",
    disabledSuffix: ", недоступен",
    close: "Закрыть",
  },
};

export default ru;
